module.exports = __webpack_public_path__ + "407c66fe01340ae7605d38df95155422.png";